import { render, staticRenderFns } from "./MortgageLeadForm.vue?vue&type=template&id=53d2f88b&"
import script from "./MortgageLeadForm.vue?vue&type=script&lang=ts&"
export * from "./MortgageLeadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports